import { render } from "./CarouselAvis.vue?vue&type=template&id=f1290154&scoped=true"
import script from "./CarouselAvis.vue?vue&type=script&lang=js"
export * from "./CarouselAvis.vue?vue&type=script&lang=js"

import "./CarouselAvis.vue?vue&type=style&index=0&id=f1290154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1290154"]])

export default __exports__